import React from 'react';
import Container from "@mui/material/Container";
import EventSetup from "./EventSetup";
import {useSelector} from "react-redux";

const Setup = () => {
    const eventId = useSelector(state => state.session.event?.id)

    return (
        <Container>
            {eventId &&
                <EventSetup eventId={eventId}/>
            }
        </Container>
    )
};

export default Setup;